import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/bank-red.svg'


const _hoisted_1 = {
  key: 0,
  class: "py-8"
}
const _hoisted_2 = {
  key: 1,
  class: "grid grid-cols-1 gap-6 py-4"
}
const _hoisted_3 = { class: "flex flex-row space-x-2 items-start" }
const _hoisted_4 = { class: "flex flex-col w-full" }
const _hoisted_5 = { class: "flex py-1.5" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-row items-center space-x-3"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6 mb-1",
  alt: "bank"
}, null, -1)
const _hoisted_8 = { class: "uppercase text-black-lp-300 text-20px font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_select_search = _resolveComponent("select-search")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ModalForm = _resolveComponent("ModalForm")!

  return (_openBlock(), _createBlock(_component_ModalForm, {
    onClose: _ctx.onResetAddBank,
    onSubmit: _ctx.onAddBank,
    title: "Tambah Rekening Bank",
    isDisabled: _ctx.isDisableFormBank,
    isFooter: 
      _ctx.errorCauseValidationBank && _ctx.errorCauseValidationBank === 'client'
    
  }, {
    content: _withCtx(() => [
      (_ctx.errorCauseValidationBank && _ctx.errorCauseValidationBank !== 'client')
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_ErrorMessage, {
              errorType: _ctx.errorCauseValidationBank,
              onTryAgain: _ctx.onCheckValidationBank
            }, null, 8, ["errorType", "onTryAgain"])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_2, [
            (_ctx.type === 'bank')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_DataWrapper, {
                    label: "Nama Bank",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_select_search, {
                        placeholder: "Pilih bank",
                        modelValue: _ctx.form.bankName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.bankName = $event)),
                        options: _ctx.bankList,
                        "key-name": "name",
                        "key-value": "value",
                        "server-side": false,
                        "is-loading": _ctx.loadingBank,
                        onFocus: _ctx.fetchListBank,
                        onChange: _ctx.onChangeBankName,
                        class: "w-full whitespace-no-wrap my-2 z-10"
                      }, null, 8, ["modelValue", "options", "is-loading", "onFocus", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "No. Rekening",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode("div", _hoisted_3, [
                        _createVNode("div", _hoisted_4, [
                          _createVNode(_component_lp_input, {
                            modelValue: _ctx.form.accountNo,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.accountNo = $event)),
                            type: "No. Rekening",
                            placeholder: !_ctx.form.bankName ? '' : 'Masukan No. rekening',
                            error: _ctx.error.accountNo || !!_ctx.errorMessage,
                            onChange: _ctx.validateAccountNo,
                            errorCaption: 
                    _ctx.errorMessage || 'No. Rekening harus format angka'
                  ,
                            disabled: !_ctx.form.bankName,
                            disableBackground: !_ctx.form.bankName
                          }, null, 8, ["modelValue", "placeholder", "error", "onChange", "errorCaption", "disabled", "disableBackground"])
                        ]),
                        _createVNode("div", _hoisted_5, [
                          _createVNode(_component_button_fill, {
                            onClick: _ctx.onCheckValidationBank,
                            title: "Periksa",
                            class: "bg-red-lp-300 px-8",
                            isDisabled: _ctx.isDisableCheck || _ctx.disableValidate,
                            isLoading: _ctx.isLoadingAddBank
                          }, null, 8, ["onClick", "isDisabled", "isLoading"])
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.form.accountName && !_ctx.isLoadingAddBank)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _hoisted_7,
                        _createVNode("p", _hoisted_8, _toDisplayString(_ctx.maskedBankAccountName), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DataWrapper, {
                    label: "Email",
                    optional: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.form.email,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.email = $event)),
                        type: "email",
                        placeholder: !_ctx.form.bankName ? '' : 'e.g email@gmail.com',
                        onChange: _ctx.validateBankEmail,
                        error: _ctx.error.email,
                        errorCaption: "Masukan Email dengan benar",
                        disabled: !_ctx.form.bankName,
                        disableBackground: !_ctx.form.bankName
                      }, null, 8, ["modelValue", "placeholder", "onChange", "error", "disabled", "disableBackground"])
                    ]),
                    _: 1
                  })
                ], 64))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_DataWrapper, {
                    label: "Nama Bank",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Select, {
                        onOpenSelect: _ctx.onOpenSelectRangeBankSettlement,
                        onCloseSelect: _ctx.onCloseSelectRangeBankSettlement,
                        isOpenMenu: _ctx.isOpenBankSettlement,
                        value: _ctx.formSettlement.bankName,
                        onChooseSelect: _ctx.onSelectRangeBankSettlement,
                        dataSelect: _ctx.vaBankNameSettlementList,
                        class: "w-full whitespace-no-wrap my-2"
                      }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "Nomor Rekening Virtual Account",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        format: _ctx.formatNumber,
                        modelValue: _ctx.formSettlement.accountNo,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formSettlement.accountNo = $event)),
                        onChange: _ctx.validateAccountNoSettlement,
                        error: _ctx.error.accountNoSettlement,
                        errorCaption: "No. Virtual Account harus format angka  ",
                        placeholder: "Masukkan nomor virtual account"
                      }, null, 8, ["format", "modelValue", "onChange", "error"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DataWrapper, {
                    label: "Nama Rekening",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.formSettlement.accountName,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formSettlement.accountName = $event)),
                        placeholder: "Masukkan nama rekening"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ], 64))
          ]))
    ]),
    _: 1
  }, 8, ["onClose", "onSubmit", "isDisabled", "isFooter"]))
}